import * as betprofessor from './MyBetsCard.styles.betprofessor';
import * as betroyale from './MyBetsCard.styles.betroyale';
import * as fiestabet from './MyBetsCard.styles.fiestabet';
import * as goldenrush from './MyBetsCard.styles.goldenrush';
import * as juicybet from './MyBetsCard.styles.juicybet';
import * as puntcity from './MyBetsCard.styles.puntcity';
import * as puntgenie from './MyBetsCard.styles.puntgenie';
import * as questbet from './MyBetsCard.styles.questbet';
import * as sterlingparker from './MyBetsCard.styles.sterlingparker';
import * as vikingbet from './MyBetsCard.styles.vikingbet';
import * as volcanobet from './MyBetsCard.styles.volcanobet';
import * as wellbet from './MyBetsCard.styles.wellbet';
import * as forsport from './MyBetsCard.styles.forsport';
import * as junglebet from './MyBetsCard.styles.junglebet';
import * as oldgill from './MyBetsCard.styles.oldgill';
import * as sugarcastle from './MyBetsCard.styles.sugarcastle';
import * as buffalobet from './MyBetsCard.styles.buffalobet';
import * as titanbet from './MyBetsCard.styles.titanbet';
import * as slambet from './MyBetsCard.styles.slambet';
import * as gigabet from './MyBetsCard.styles.gigabet';
import * as betstride from './MyBetsCard.styles.betstride';
import * as templebet from './MyBetsCard.styles.templebet';
import * as goldenbet888 from './MyBetsCard.styles.goldenbet888';
import * as hyperbet from './MyBetsCard.styles.hyperbet';
import * as bet777 from './MyBetsCard.styles.bet777';
import * as chromabet from './MyBetsCard.styles.chromabet';
import * as bet575 from './MyBetsCard.styles.bet575';
import * as epicodds from './MyBetsCard.styles.epicodds';
import * as pyramidbet from './MyBetsCard.styles.pyramidbet';
import * as magnumbet from './MyBetsCard.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betprofessor,
  betroyale,
  fiestabet,
  goldenrush,
  juicybet,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  wellbet,
  forsport,
  junglebet,
  oldgill,
  sugarcastle,
  buffalobet,
  titanbet,
  slambet,
  gigabet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  epicodds,
  pyramidbet,
  magnumbet,
};
